import React, { useState, useEffect } from "react";
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Button,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get, api } from "../../../utils/api";
import {
  textError,
  percentageError,
  numberError,
} from "../../../utils/validationMessage";
import styles from "../../../styles/brsr/general.module.css";
import DynamicTable from "../../Common/DynamicTable";
import { validateTable } from "../../../utils/validateTable";
import { restructureData } from "../../../utils/restructureData";
import ReusableTable from "../../Common/ReusableTable";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import style from "../../../styles/brsr/general.module.css";
import { currentYear } from "../../../utils/generateYearRanges";
import BRSRFile from "../../Common/BRSRFile";
import AddIcon from "@mui/icons-material/Add";

const Transparency = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tables, setTables] = useState([]);
  const [data, setData] = useState({});
  const [modalupload, setModalUpload] = useState({
    currentAndPreviousFYComplaintsDoc: false,
    materialIssuesDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    currentFYComplaints: {
      communities: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      investors: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      shareHolders: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      employeesAndWorkers: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      customers: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      valueChainParnter: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
      other: {
        grievanceRedressalWeblink: "",
        filed: "",
        pending: "",
        remarks: "",
      },
    },
    // ],
    previousFYComplaints:
      //  [
      {
        communities: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        investors: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        shareHolders: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        employeesAndWorkers: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        customers: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        valueChainParnter: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
        other: {
          grievanceRedressalWeblink: "",
          filed: "",
          pending: "",
          remarks: "",
        },
      },
  });
  const headers = [
    {
      title: "Stakeholder group from whom complaint is received",
      placeholder: "Web-Link",
      filedName: "grievanceRedressalWeblink",
    },
    {
      title:
        "Grievance Redressal Mechanism in Place (If Yes, then provide web-link for grievance redress policy)",
      placeholder: "Enter Number",
      filedName: "filed",
    },
    {
      title: "Number of complaints filed during the year",
      placeholder: "Enter Number",
      filedName: "pending",
    },
    {
      title: "Number of complaints pending resolution at close of the year",
      placeholder: "Remarks",
      filedName: "remarks",
    },
  ];

  const inputData = [
    {
      fieldName: "materialIssues",
      type: "array",

      fields: [
        {
          fieldName: "issueIdentify",
          title: "Material issue identified",
          placeholder: "Enter Here",
          type: "text",
          width: "10rem",
        },
        {
          fieldName: "riskOrOpportunity",
          title: "Indicate whether risk or opportunity (R/O)",
          placeholder: "Enter Here",
          type: "select",
          width: "10rem",
          options: ["Risk", "Opportunity"],
        },
        {
          fieldName: "rationale",
          title: "Rationale for identifying the risk / opportunity",
          placeholder: "Enter Here",
          type: "text",
          width: "10rem",
        },
        {
          fieldName: "mitigationApproach",
          title: "In case of risk, approach to adapt or mitigate",
          placeholder: "Enter Here",
          type: "text",
          width: "10rem",
        },
        {
          fieldName: "financialImplications",
          title:
            "Financial implications of the risk or opportunity (Indicate positive or negative implications)",
          placeholder: "Enter Here",
          type: "text",
          width: "10rem",
        },
      ],
    },
  ];

  const supplierRows = [
    {
      label: "Communities",
      key: "communities",
    },
    {
      label: "Investors",
      key: "investors",
    },
    {
      label: "Shareholders",
      key: "shareHolders",
    },
    {
      label: "Employees & Workers",
      key: "employeesAndWorkers",
    },
    {
      label: "Customers",
      key: "customers",
    },
    {
      label: "Value Chain Partners",
      key: "valueChainParnter",
    },
    {
      label: "Other (Please Specify)",
      key: "other",
    },
  ].map((item) => ({
    Location: item.label,
    grievanceRedressalWeblink:
      formData.currentFYComplaints?.[item.key]?.grievanceRedressalWeblink,
    filed: formData.currentFYComplaints?.[item.key]?.filed,
    pending: formData.currentFYComplaints?.[item.key]?.pending,
    remarks: formData.currentFYComplaints?.[item.key]?.remarks,
  }));

  const supplierRowsPervious = [
    {
      label: "Communities",
      key: "communities",
    },
    {
      label: "Investors",
      key: "investors",
    },
    {
      label: "Shareholders",
      key: "shareHolders",
    },
    {
      label: "Employees & Workers",
      key: "employeesAndWorkers",
    },
    {
      label: "Customers",
      key: "customers",
    },
    {
      label: "Value Chain Partners",
      key: "valueChainParnter",
    },
    {
      label: "Other (Please Specify)",
      key: "other",
    },
  ].map((item) => ({
    Location: item.label,
    grievanceRedressalWeblink:
      formData.previousFYComplaints?.[item.key]?.grievanceRedressalWeblink,
    filed: formData.previousFYComplaints?.[item.key]?.filed,
    pending: formData.previousFYComplaints?.[item.key]?.pending,
    remarks: formData.previousFYComplaints?.[item.key]?.remarks,
  }));

  const columns = [
    {
      label: "Stakeholder group from whom complaint is received",
      field: "Location",
      type: "disabled",
      width: "16%",
    },
    {
      label:
        "Grievance Redressal Mechanism in Place (If Yes, then provide web-link for grievance redress policy)",
      field: "grievanceRedressalWeblink",
      type: "weblink",
      placeholder: "Web-Link",
      width: "20%",
    },
    {
      label: "Number of complaints filed during the year",
      field: "filed",
      type: "number",
      width: "15%",
    },
    {
      label: "Number of complaints pending resolution at close of the year",
      field: "pending",
      type: "number",
      width: "15%",
    },
    {
      label: "Remarks",
      field: "remarks",
      type: "text",
      placeholder: "Remarks",
      width: "10%",
    },
  ];

  const [errors, setErrors] = useState({}); // State to track errors
  const [errorstable, setErrorsTable] = useState({});
  const [rows, setRows] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handleChange = (section, type, key, field, value) => {
    if (type === "number") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }
    // if (type === "weblink") {
    //   const regex =
    //     /^(https?:\/\/)?(www\.)?(([\p{L}0-9-]+\.)+[\p{L}]{2,}|(\d{1,3}\.){3}\d{1,3})(:\d{2,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/u;
    //   if (regex.test(value)) return;
    // }

    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: {
          ...prev[section][key],
          [field]: value,
        },
      },
    }));
  };
  // const handleSubmit = async () => {
  //   if (!validateTable(inputData, tables, setErrors)) return;

  //   let transformedData = restructureData(tables);

  //   transformedData = { ...transformedData, ...formData,type: "SectionA" };

  // };

  // Validation function

  const validateForm = () => {
    let newErrors = {};

    // Function to validate complaints and remove empty objects
    // const validateComplaints = (category, formDataCategory) => {
    //   if (!newErrors[category]) {
    //     newErrors[category] = {};
    //   }

    //   Object.keys(formDataCategory).forEach((location, rowIndex) => {
    //     const jobData = formDataCategory[location];

    //     // Ensure the location entry exists
    //     if (!newErrors[category][location]) {
    //       newErrors[category][location] = {};
    //     }

    //     let missingFields = [];

    //     Object.entries(jobData).forEach(([field, value]) => {
    //       if (value === "" || value === null) {
    //         missingFields.push(field);
    //         newErrors[category][location][field] = `${field} is required`;
    //       }else  if (field === "grievanceRedressalWeblink") {
    //         const websiteRegex = /^www\.[a-zA-Z0-9-]+\.[a-z]{2,}$/;
    //         if (!websiteRegex.test(value)) {
    //           newErrors[category][location]["errorSummary"] =
    //             `Row ${
    //         rowIndex + 1
    //       }:Invalid website format (e.g., www.test.com)`;
    //         }
    //       }
    //     });

    //     if (missingFields.length > 0) {
    //       newErrors[category][location]["errorSummary"] = `Row ${
    //         rowIndex + 1
    //       }: Missing fields - ${missingFields.join(", ")}`;
    //     }

    //     // If no errors exist for the location, remove it from newErrors
    //     if (Object.keys(newErrors[category][location]).length === 0) {
    //       delete newErrors[category][location];
    //     }
    //   });

    //   // If no errors exist for the category, remove it from newErrors
    //   if (Object.keys(newErrors[category]).length === 0) {
    //     delete newErrors[category];
    //   }
    // };

    const validateComplaints = (category, formDataCategory) => {
      if (!newErrors[category]) {
        newErrors[category] = {};
      }

      Object.keys(formDataCategory)
        .filter((location) => location !== "other")
        .forEach((location, rowIndex) => {
          const jobData = formDataCategory[location];
          if (!newErrors[category][location]) {
            newErrors[category][location] = {};
          }

          let missingFields = [];
          let invalidFields = [];

          Object.entries(jobData).forEach(([field, value]) => {
            if ((value === "" || value === null) && field !== "remarks") {
              missingFields.push(field);
              newErrors[category][location][field] = `${field} is required`;
            } else if (field === "grievanceRedressalWeblink") {
              const websiteRegex =
                /^(https?:\/\/)?(www\.)?(([\p{L}0-9-]+\.)+[\p{L}]{2,}|(\d{1,3}\.){3}\d{1,3})(:\d{2,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/u;
              if (!websiteRegex.test(value)) {
                invalidFields.push(field);
                newErrors[category][location][field] =
                  "Invalid website format (e.g., www.test.com)";
              }
            }
          });

          // Combine missing and invalid fields into one summary
          if (missingFields.length > 0 || invalidFields.length > 0) {
            let summaryParts = [];
            if (missingFields.length > 0) {
              summaryParts.push(`Missing fields - ${missingFields.join(", ")}`);
            }
            if (invalidFields.length > 0) {
              summaryParts.push(`Invalid fields - ${invalidFields.join(", ")}`);
            }

            newErrors[category][location]["errorSummary"] = `Row ${
              rowIndex + 1
            }: ${summaryParts.join(" | ")}`;
          }

          // Clean up if no errors remain
          if (Object.keys(newErrors[category][location]).length === 0) {
            delete newErrors[category][location];
          }
        });

      if (Object.keys(newErrors[category]).length === 0) {
        delete newErrors[category];
      }
    };

    // Validate both currentFYComplaints and previousFYComplaints
    validateComplaints("currentFYComplaints", formData.currentFYComplaints);
    validateComplaints("previousFYComplaints", formData.previousFYComplaints);

    setErrors(newErrors);

    // Returns `true` if no errors exist
    return Object.keys(newErrors).length > 0 ? newErrors : false;
  };

  const handleUploadDocument = (key) => {
    setModalUpload((prev) => ({
      ...prev,
      [key]: true,
    }));
    setOpen(true);
  };

  const fetchData = async () => {
    await get(`${api}/brsr/get?type=SectionA&id=${id}`)
      .then((res) => {
        const transparency =
          res?.data?.data?.BRSRSectionA?.transparencyAndDisclosures || [];
        const forCurrentFY = transparency?.currentFYComplaints;
        const forPerviousFY = transparency?.previousFYComplaints;
        if (
          res?.data?.data?.year
            ? res?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);
        setData(transparency);
        setFormData({
          currentFYComplaints:
            // [
            {
              communities: {
                grievanceRedressalWeblink:
                  forCurrentFY?.communities?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.communities?.filed ?? "",
                pending: forCurrentFY?.communities?.pending ?? "",
                remarks: forCurrentFY?.communities?.remarks ?? "",
              },
              investors: {
                grievanceRedressalWeblink:
                  forCurrentFY?.investors?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.investors?.filed ?? "",
                pending: forCurrentFY?.investors?.pending ?? "",
                remarks: forCurrentFY?.investors?.remarks ?? "",
              },
              shareHolders: {
                grievanceRedressalWeblink:
                  forCurrentFY?.shareHolders?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.shareHolders?.filed ?? "",
                pending: forCurrentFY?.shareHolders?.pending ?? "",
                remarks: forCurrentFY?.shareHolders?.remarks ?? "",
              },
              employeesAndWorkers: {
                grievanceRedressalWeblink:
                  forCurrentFY?.employeesAndWorkers
                    ?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.employeesAndWorkers?.filed ?? "",
                pending: forCurrentFY?.employeesAndWorkers?.pending ?? "",
                remarks: forCurrentFY?.employeesAndWorkers?.remarks ?? "",
              },
              customers: {
                grievanceRedressalWeblink:
                  forCurrentFY?.customers?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.customers?.filed ?? "",
                pending: forCurrentFY?.customers?.pending ?? "",
                remarks: forCurrentFY?.customers?.remarks ?? "",
              },
              valueChainParnter: {
                grievanceRedressalWeblink:
                  forCurrentFY?.valueChainParnter?.grievanceRedressalWeblink ??
                  "",
                filed: forCurrentFY?.valueChainParnter?.filed ?? "",
                pending: forCurrentFY?.valueChainParnter?.pending ?? "",
                remarks: forCurrentFY?.valueChainParnter?.remarks ?? "",
              },
              other: {
                grievanceRedressalWeblink:
                  forCurrentFY?.other?.grievanceRedressalWeblink ?? "",
                filed: forCurrentFY?.other?.filed ?? "",
                pending: forCurrentFY?.other?.pending ?? "",
                remarks: forCurrentFY?.other?.remarks ?? "",
              },
            },
          // ],
          previousFYComplaints:
            // [
            {
              communities: {
                grievanceRedressalWeblink:
                  forPerviousFY?.communities?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.communities?.filed ?? "",
                pending: forPerviousFY?.communities?.pending ?? "",
                remarks: forPerviousFY?.communities?.remarks ?? "",
              },
              investors: {
                grievanceRedressalWeblink:
                  forPerviousFY?.investors?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.investors?.filed ?? "",
                pending: forPerviousFY?.investors?.pending ?? "",
                remarks: forPerviousFY?.investors?.remarks ?? "",
              },
              shareHolders: {
                grievanceRedressalWeblink:
                  forPerviousFY?.shareHolders?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.shareHolders?.filed ?? "",
                pending: forPerviousFY?.shareHolders?.pending ?? "",
                remarks: forPerviousFY?.shareHolders?.remarks ?? "",
              },
              employeesAndWorkers: {
                grievanceRedressalWeblink:
                  forPerviousFY?.employeesAndWorkers
                    ?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.employeesAndWorkers?.filed ?? "",
                pending: forPerviousFY?.employeesAndWorkers?.pending ?? "",
                remarks: forPerviousFY?.employeesAndWorkers?.remarks ?? "",
              },
              customers: {
                grievanceRedressalWeblink:
                  forPerviousFY?.customers?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.customers?.filed ?? "",
                pending: forPerviousFY?.customers?.pending ?? "",
                remarks: forPerviousFY?.customers?.remarks ?? "",
              },
              valueChainParnter: {
                grievanceRedressalWeblink:
                  forPerviousFY?.valueChainParnter?.grievanceRedressalWeblink ??
                  "",
                filed: forPerviousFY?.valueChainParnter?.filed ?? "",
                pending: forPerviousFY?.valueChainParnter?.pending ?? "",
                remarks: forPerviousFY?.valueChainParnter?.remarks ?? "",
              },
              other: {
                grievanceRedressalWeblink:
                  forPerviousFY?.other?.grievanceRedressalWeblink ?? "",
                filed: forPerviousFY?.other?.filed ?? "",
                pending: forPerviousFY?.other?.pending ?? "",
                remarks: forPerviousFY?.other?.remarks ?? "",
              },
            },
        });
        // setTables(
        //   transparency?.materialIssues.length > 0
        //     ? transparency?.materialIssues
        //     : [
        //         {
        //           fieldName: "materialIssues",
        //           rows: [
        //             {
        //               issueIdentify: "",
        //               riskOrOpportunity: "",
        //               rationale: "",
        //               mitigationApproach: "",
        //               financialImplications: "",
        //             },
        //           ],
        //         },
        //       ]
        // );
      })
      .catch((err) => {
        console.log(err, "fetching data");
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    // Validate before submitting
    let v1 = validateTable(inputData, tables, setErrorsTable);
    if (!disabled) {
      if (validateForm() || !v1) {
        return; // Do not proceed if validation fails
      }
      let transformedData = restructureData(tables);

      transformedData = { ...transformedData, ...formData };

      try {
        const data = {
          transparencyAndDisclosures: { ...transformedData },
          type: "SectionA",
          transparencyAndDisclosuresSubmitted: true,
        };

        await put(`/brsr/update?id=${id}`, data);
        navigate(`/brsr/section-b/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
      }
    } else navigate(`/brsr/section-b/${id}`);
  };

  return (
    <Box>
      <p className={style.subHeading}>
        VII. TRANSPARENCY & DISCLOSURES COMPLIANCES
      </p>

      {/* Table for Number of Locations */}
      <Typography
        sx={{ fontWeight: 600, fontSize: "16px", mt: 3 }}
        gutterBottom
      >
        25.Complaints/Grievances on any of the principles (Principles 1 to 9)
        under the National Guidelines on Responsible Business Conduct:
      </Typography>
      <ReusableTable
        title=" a. Current Financial Year"
        rows={supplierRows}
        columns={columns}
        disabled={disabled}
        data={formData.currentFYComplaints}
        errors={errors?.currentFYComplaints}
        setRows={setRows}
        onChange={(rowIndex, type, field, value) =>
          handleChange(
            "currentFYComplaints",
            type,
            Object.keys(formData.currentFYComplaints)[rowIndex],
            field,
            value,
          )
        }
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <ReusableTable
        title=" b. Previous Financial Year"
        rows={supplierRowsPervious}
        columns={columns}
        disabled={disabled}
        data={formData.previousFYComplaints}
        errors={errors?.previousFYComplaints}
        setRows={setRows}
        onChange={(rowIndex, type, field, value) =>
          handleChange(
            "previousFYComplaints",
            type,
            Object.keys(formData.previousFYComplaints)[rowIndex],
            field,
            value,
          )
        }
      />

      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "currentAndPreviousFYComplaintsDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        sx={{ fontWeight: 600, fontSize: "16px", mt: 3 }}
        gutterBottom
      >
        26.Overview of the entity’s material responsible business conduct issues
      </Typography>
      <Typography variant="subtitle1" sx={{ margin: "0px 17px" }} gutterBottom>
        Please indicate material responsible business conduct and sustainability
        issues pertaining to environmental and social matters that present a
        risk or an opportunity to your business, rationale for identifying the
        same, approach to adapt or mitigate the risk along-with its financial
        implications, as per the following format
      </Typography>
      <DynamicTable
        {...{
          inputData,
          tables,
          // handleSubmit,
          setTables,
          errors,
          setErrors,
          disabled,
          data,
          hide,
          ml: "1.5rem",
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "materialIssuesDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {/* Save Button */}
      {!hide && (
        <>
          {" "}
          {brsrReview ? (
            <Box sx={{ ml: 3, width: "98%" }}>
              <ReviewBox url={`/brsr/review/${id}`} handleSubmit={handleSave} />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSave}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default Transparency;
